import { render, staticRenderFns } from "./UserRolesAddEdit.vue?vue&type=template&id=a48994de"
import script from "./UserRolesAddEdit.vue?vue&type=script&lang=js"
export * from "./UserRolesAddEdit.vue?vue&type=script&lang=js"
import style0 from "./UserRolesAddEdit.vue?vue&type=style&index=0&id=a48994de&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports